import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  Alert,
  AlertIcon,
  useColorModeValue,
} from "@chakra-ui/react";
import { useState } from "react";
import { Link as RouterLink, useHistory } from "react-router-dom";
import axios from "axios";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [signupError, setSignupError] = useState(false);

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitLoading(true);
      await axios.post("/auth/signup", {
        username,
        email,
        password,
      });
      history.push("/dashboard");
    } catch (error) {
      setSubmitLoading(false);
      setSignupError(error.response.data.message);
    }
  };
  return (
    <Flex
      height={"100%"}
      direction="column"
      alignItems={"center"}
      justifyContent={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={8} maxW={"lg"} py={4} px={6}>
        <Stack align={"center"}>
          <Heading fontSize={"4xl"}>Sign Up</Heading>
          <Text fontSize={"lg"} color={"gray.600"}>
            to enjoy all of our cool{" "}
            <Link as={RouterLink} to="/about" color={"blue.400"}>
              features
            </Link>{" "}
            ✌️
          </Text>
        </Stack>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
        >
          <Stack spacing={4} w={"72"}>
            <form onSubmit={handleSubmit}>
              <FormControl id="username">
                <FormLabel>Username</FormLabel>
                <Input
                  type="text"
                  autoComplete="on"
                  onChange={(e) => setUsername(e.target.value)}
                />
              </FormControl>
              <FormControl id="email">
                <FormLabel>Email address</FormLabel>
                <Input
                  type="email"
                  autoComplete="on"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </FormControl>
              <FormControl id="password">
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: "column", sm: "row" }}
                  align={"start"}
                  justify={"space-between"}
                >
                  <Checkbox>Remember me</Checkbox>
                  <Link as={RouterLink} to="/login" color={"blue.400"}>
                    Already A Member?
                  </Link>
                </Stack>
                {!submitLoading ? (
                  <Button
                    bg={"blue.400"}
                    color={"white"}
                    _hover={{
                      bg: "blue.500",
                    }}
                    size="lg"
                    type="submit"
                  >
                    Sign Up
                  </Button>
                ) : (
                  <Button
                    bg={"blue.400"}
                    color={"white"}
                    _hover={{
                      bg: "blue.500",
                    }}
                    variant="outline"
                    spinnerPlacement="end"
                    isLoading
                    loadingText="Loggin You In"
                  >
                    Sign Up
                  </Button>
                )}
              </Stack>
            </form>
            {signupError ? (
              <Alert status="error">
                <AlertIcon />
                {signupError
                  ? signupError
                  : "There was an error processing your request"}
              </Alert>
            ) : null}
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
};

export default Login;
